import { render, staticRenderFns } from "./Alarm.vue?vue&type=template&id=4bf5fe2e&"
import script from "./Alarm.vue?vue&type=script&lang=js&"
export * from "./Alarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports